import React from "react";
import PropTypes from "prop-types";
import { FaCheck, FaTimes } from "react-icons/fa";

const Step7 = ({ impuestoCalculado }) => {
  if (!impuestoCalculado) {
    return (
      <div className="p-4 text-gray-600">
        No hay datos de impuestos para mostrar.
      </div>
    );
  }

  const { alcabala, utilidad, devaluacion } = impuestoCalculado;

  const formatearValor = (valor, concepto) => {
    if (typeof valor === 'boolean' || (typeof valor === 'string' && (valor.toLowerCase() === 'true' || valor.toLowerCase() === 'false'))) {
      const esVerdadero = valor === true || valor.toLowerCase() === 'true';
      return esVerdadero ?
        <span className="text-green-600"><FaCheck /></span> :
        <span className="text-red-600"><FaTimes /></span>;
    }

    if (concepto.toLowerCase().includes('porcentaje')) {
      const valorNumerico = parseFloat(valor);
      if (!isNaN(valorNumerico)) {
        return `${valorNumerico.toFixed(2)}%`;
      }
    }

    const valorNumerico = parseFloat(valor);
    if (!isNaN(valorNumerico)) {
      return valorNumerico.toFixed(2);
    }

    return valor;
  };

  const renderTabla = (titulo, datos) => {
    return (
      <div>
        <h3 className="text-lg font-semibold mb-2">{titulo}</h3>
        <div className="overflow-x-auto rounded-lg border border-gray-300">
          <table className="w-full table-auto text-left text-sm">
            <thead className="bg-gray-100 font-semibold text-gray-700">
              <tr>
                <th className="px-4 py-2">Concepto</th>
                <th className="px-4 py-2 text-right">Valor</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(datos.detalles || {}).map(([concepto, valor], index) => (
                <tr
                  key={`${titulo.toLowerCase()}-${index}`}
                  className="hover:bg-gray-200"
                >
                  <td className="px-4 py-2">{concepto}</td>
                  <td className="px-4 py-2 flex justify-end w-full">{formatearValor(valor, concepto)}</td>
                </tr>
              ))}
              <tr className="bg-gray-50 font-semibold">
                <td className="px-4 py-2">Total</td>
                <td className="px-4 py-2 text-right">${parseFloat(datos.total || '0').toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="mt-4">
      {renderTabla("Alcabala", alcabala)}
      {renderTabla("Utilidad", utilidad)}
      {renderTabla("Devaluación", devaluacion)}

      <div className="mt-6 p-4 bg-gray-50 rounded-lg border border-gray-300">
        <h3 className="text-lg font-semibold mb-2">Total a Pagar</h3>
        <div className="flex justify-between items-center">
          <span>Alcabala + Utilidad:</span>
          <span className="text-xl font-bold">
            ${(parseFloat(alcabala.total || '0') + parseFloat(utilidad.total || '0')).toFixed(2)}
          </span>
        </div>
      </div>
    </div>
  );
};

Step7.propTypes = {
  impuestoCalculado: PropTypes.shape({
    alcabala: PropTypes.object,
    utilidad: PropTypes.object,
    devaluacion: PropTypes.object
  })
};

export default Step7;